import axios from 'axios'
import qs from 'qs'
import baseFunc from '../util/base'
import {  Indicator } from "mint-ui";
import reportService from "./reportService"
export default class {
    Get(url, data) {
        data = baseFunc.prototype.encryption(data);
        return new Promise((resolve, reject) => {
            axios.get(url, {
                params: data
            },
            {withCredentials:true}).then((res) => {
                //成功回调
                resolve(res);
            }).catch((error) => {
                if(data.Photo){
                    delete data.Photo 
                }
                var stringdata={
                    URL:url,
                    Params:data,
                    Method:'GET',
                    Code:error.Code,
                    Response:error.Message
                   }
                reportService.prototype.Errorreport(
                      {
                          Category: 3,
                          Instance: 'android',
                          Content: JSON.stringify(stringdata),
                      }
                  )
                reject(error);
            })
        })
    }
    Post(url, data) {
        data = baseFunc.prototype.encryption(data);
        return new Promise((resolve, reject) => {
            // showFullScreenLoading()
            axios.post(url, qs.stringify(data), {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Accept': 'application/json'
                },
                
            },
            {withCredentials:true}).then((res) => {
                //成功回调
                resolve(res);
            }).catch((error) => {
                if(data.Photo){
                    delete data.Photo 
                }
                var stringdata={
                    URL:url,
                    Params:data,
                    Method:'POST',
                    Code:error.Code,
                    Response:error.Message
                   }
                reportService.prototype.Errorreport(
                      {
                          Category:3,
                          Instance: 'android',
                          Content: JSON.stringify(stringdata),
                      }
                  )
                reject(error)
            })
        })
    }
    //返回一个Promise(发送post请求)
     Put(url, data) {
    data = baseFunc.prototype.encryption(data);
    return new Promise((resolve, reject) => {
        axios.put(url, data,{withCredentials:true})
            .then(response => {
                resolve(response);
            }, err => {
                reject(err);
            })
            .catch((error) => {
                if(data.Photo){
                    delete data.Photo 
                }
                var stringdata={
                    URL:url,
                    Params:data,
                    Method:'POST',
                    Code:error.Code,
                    Response:error.Message
                   }
                reportService.prototype.Errorreport(
                      {
                          Category:3,
                          Instance: 'android',
                          Content: JSON.stringify(stringdata),
                      }
                  )
                reject(error)
            })
    })
}
    PostFlie(url, data) {
        data = baseFunc.prototype.encryption(data);
        return new Promise((resolve, reject) => {
            //根据data对象生成FormData对象
            var temp = new FormData();
            for (var t in data) {
                temp.append(t, data[t]);
            }
            axios.post(url, temp).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error);
            })
        })
    }
}


// WEBPACK FOOTER //
// ./src/service/http.js